import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/adam.plocieniak/GIT/kick-video-downloader/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/Users/adam.plocieniak/GIT/kick-video-downloader/components/navbar.tsx");
